export default __webpack_public_path__ + "static/media/unsere_haeuser_web-sm@2x.be6854f7.webp";